import { List } from "immutable";

import { IdByTypeReferenceList } from "../types/immutableRecords/helper/IdByTypeReferenceList";
import { IdReferenceList } from "../types/immutableRecords/helper/IdReferenceList";

export const idReferenceGenerator = objectArray =>
  objectArray
    ? objectArray.reduce(
      (idRef, obj) => idRef.setIn(["byId", obj.id], obj).update("allIds", allIds => allIds.push(obj.id)),
      IdReferenceList()
    )
    : IdReferenceList();

export const idByTypeReferenceGenerator = objectArray => {
  const res = objectArray.reduce(
    (idRef, obj) =>
      idRef
        .setIn(["byId", obj.id], obj)
        .update("allIds", ids => ids.push(obj.id))
        .updateIn(["allIdsForType", obj.type], ids => (ids && ids.size ? ids.push(obj.id) : List([obj.id]))),
    IdByTypeReferenceList()
  );
  return res;
};
